import { Card, Button, Input, Tooltip } from 'antd'
import { useState } from 'react'
import styled from 'styled-components'
import { PlusOutlined, MinusOutlined, CheckOutlined, DeleteOutlined } from '@ant-design/icons'
import ImagePreview, { getImageUrl, isImageUrl } from 'src/common/components/ImagePreview'

export const CartItemWrapper = styled.div`
   .card-row {
      padding-right: 4px;
   }
   .card-item {
      margin: 0;
      flex: 1 1 auto;
      border: 0;
      border-bottom: 1px solid #f0f0f0;
      border-radius: 0;
      background: transparent;
      box-shadow: none;
   }
   .card-item .ant-card-body {
      padding: 8px 8px 10px 8px !important;
   }
   .card-item:hover {
      background: #fafafa;
   }
   .card-item.highlight {
      background: #f6ffed;
   }
   .card-item.highlight:hover {
      background: #f0ffe5;
   }
   &:last-child .card-item {
      border-bottom: 0;
   }
   .card-item .avatar {
      flex-shrink: 0;
   }
   .card-item .info {
      flex: 1 1 auto;
   }
   .card-item .info .name {
      font-size: 0.7rem;
      font-weight: 500;
   }
   .card-item .info .description {
      color: gray;
   }
   .card-item .info .price {
      color: green;
      font-size: 0.65rem;
      padding-right: 8px;
   }
   .card-item .quantity {
      flex-shrink: 0;
      font-size: 0.7rem;

      .quantity-input {
         width: 100%;
         text-align: center;
         border: 0.1px solid #cdcdcd80;

         &:focus {
            outline: 1px solid #038fde;
         }
      }
   }
   .card-item .selection-status {
      flex-shrink: 0;
      width: 28px;
      min-width: 28px;
      margin-left: 10px;
      display: inline-flex;
      align-items: center;
      justify-content: center;
      height: 28px;
      padding: 0;
      border-radius: 4px;
      color: #595959;
      background: #f5f5f5;
      font-size: 14px;
   }
   .card-item .selection-status.selected {
      color: #237804;
      background: #d9f7be;
   }
   .card-item .product-links {
      margin-top: 8px;
      display: grid;
      grid-template-columns: 1fr 1fr;
      gap: 10px;
   }
   .card-item .product-link-field label {
      display: block;
      margin-bottom: 4px;
      color: #595959;
      font-size: 11px;
      line-height: 14px;
   }
   .card-item .product-link-field .ant-input {
      height: 28px;
      font-size: 12px;
      border-color: transparent;
      background: #f7f8fa;
      box-shadow: none;
   }
   .card-item .product-link-field .ant-input:hover,
   .card-item .product-link-field .ant-input:focus {
      border-color: #40a9ff;
      background: #fff;
   }
   .card-item .my-link-design {
      margin-top: 8px;
   }
   .card-item .my-link-design label {
      display: block;
      margin-bottom: 4px;
      color: #595959;
      font-size: 11px;
      line-height: 14px;
   }
   .card-item .my-link-design .my-link-design-value {
      font-size: 12px;
      word-break: break-all;
   }
   .card-item .my-link-design .my-link-design-empty {
      color: #bfbfbf;
      font-size: 12px;
   }
   .trash-wrapper {
      i {
         cursor: pointer;
         color: #ff3b30;
         &:hover {
            &.icon-color {
               color: #ff3b30;
            }
         }
      }
   }

   .ant-btn-circle {
      min-width: 28px;
      // line-height: 27px;
   }

   .ant-btn-icon-only {
      width: 28px;
      height: 28px;
   }

   @media screen and (max-width: 575px) {
      .ant-btn {
         margin-bottom: 0;
      }
      .card-item .product-links {
         grid-template-columns: 1fr;
      }
   }
`
const CardItem = ({
   item,
   type = null,
   onClick,
   className,
   onDelete,
   onChange,
   imageSize = 36,
   showProductLinks,
   showMyLinkDesign,
   readOnlyProductLinks,
   showSelectionStatus,
   isSelected,
   onProductLinkChange
}: any) => {
   const [quantity, setQuantity] = useState(item.qty ? item.qty : 1)

   const increasement = () => {
      setQuantity(quantity + 1)
      onChange(quantity + 1)
   }
   const decreasement = () => {
      if (quantity <= 0) return
      const newQty = quantity - 1
      if (newQty === 0) {
         onDelete?.()
         return
      }
      setQuantity(newQty)
      onChange(newQty)
   }

   const handleChangeQuantity = (value: any) => {
      if (value.length > 6) return
      if (value < 0) return
      const numValue = parseInt(value, 10)
      if (numValue === 0) {
         onDelete?.()
         return
      }
      setQuantity(value)
      onChange(value)
   }

   const handleOnBlur = (value: any) => {
      const quantity = value.replace(/^0+/, '')

      if (quantity === '' || quantity === '0') {
         onDelete?.()
         return
      }

      setQuantity(quantity)
   }

   const handleChangeProductLink = (field: 'linkMockup' | 'linkDesign' | 'myLinkDesign', value: string) => {
      item[field] = value
      onProductLinkChange?.(field, value)
   }

   return (
      <CartItemWrapper>
         <div className="gx-d-flex gx-align-items-center card-row" onClick={onClick}>
            <Card bodyStyle={{ padding: '4px 8px 4px 8px' }} className={`card-item ${className}`}>
               <div>
                  <div className="gx-d-flex gx-align-items-center ">
                     <ImagePreview
                        wrapperClassName="gx-mr-2 avatar"
                        size={imageSize}
                        fit="contain"
                        src={getImageUrl(item?.images?.[0] || '', process.env.REACT_APP_IMAGE_ENDPOINT)}
                     />
                     <div className="info">
                        <div className="name">
                           <span
                              style={{
                                 textTransform: 'capitalize',
                                 border: 1,
                                 background: '#cdcdcd',
                                 borderRadius: 2,
                                 paddingLeft: 4,
                                 paddingRight: 4,
                                 marginRight: 4
                              }}
                           >
                              #{item?.id}
                           </span>
                           {item?.name}
                        </div>
                        <div className="description">{item?.description}</div>
                        <div style={{}}>
                           {item?.base_cost && <span className="price">{`${item?.base_cost}$`}</span>}
                           {item?.listTags &&
                              item?.listTags?.map((it: any, index: number) => {
                                 return (
                                    <span
                                       key={index}
                                       style={{
                                          textTransform: 'capitalize',
                                          border: 1,
                                          background: '#cdcd',
                                          borderRadius: 2,
                                          paddingLeft: 4,
                                          paddingRight: 4,
                                          marginRight: 4,
                                          fontSize: 9
                                       }}
                                    >
                                       #{it?.name}
                                    </span>
                                    // <Tag color="gold" style={{ textTransform: 'capitalize', fontSize: 8 }} key={index}>
                                    //    {it?.name}
                                    // </Tag>
                                 )
                              })}
                        </div>
                     </div>
                     {type === 'edit' ? (
                        <div
                           className="gx-d-flex gx-align-items-center"
                           style={{ marginLeft: 4, alignItems: 'center', justifyContent: 'center' }}
                        >
                           <Button
                              type="primary"
                              size="small"
                              // shape="circle"
                              icon={<MinusOutlined />}
                              style={{ marginRight: 4 }}
                              onClick={decreasement}
                              disabled={quantity <= 0}
                           ></Button>
                           <div className="quantity" style={{ width: '40px', textAlign: 'center' }}>
                              <input
                                 type="number"
                                 className="quantity-input"
                                 value={quantity}
                                 onChange={(e: any) => handleChangeQuantity(e.target.value)}
                                 onBlur={(e: any) => handleOnBlur(e.target.value)}
                              ></input>
                           </div>
                           <Button
                              // shape="circle"
                              type="primary"
                              size="small"
                              // shape="circle"
                              icon={<PlusOutlined />}
                              style={{ marginLeft: 4 }}
                              onClick={increasement}
                              disabled={quantity >= 999999}
                           ></Button>
                        </div>
                     ) : null}
                     {type === 'view' ? <div className="quantity">Số lượng: {quantity}</div> : null}
                     {showSelectionStatus && (
                        <Tooltip title={isSelected ? 'Đã chọn' : 'Chọn sản phẩm'}>
                           <div
                              className={`selection-status ${isSelected ? 'selected' : ''}`}
                              role="button"
                              aria-label={isSelected ? 'Đã chọn' : 'Chọn sản phẩm'}
                           >
                              {isSelected ? <CheckOutlined /> : <PlusOutlined />}
                           </div>
                        </Tooltip>
                     )}
                  </div>

                  {showProductLinks && (
                     <div className="product-links">
                        <div className="product-link-field">
                           <label>Link Mockup</label>
                           <Input.TextArea
                              autoSize={{ minRows: 1, maxRows: 3 }}
                              defaultValue={item?.linkMockup}
                              maxLength={2000}
                              readOnly={readOnlyProductLinks}
                              placeholder="Link mockup cho sản phẩm này"
                              onChange={(e) => handleChangeProductLink('linkMockup', e.target.value)}
                           />
                        </div>
                        <div className="product-link-field">
                           <label>Link Design</label>
                           <Input.TextArea
                              autoSize={{ minRows: 1, maxRows: 3 }}
                              defaultValue={item?.linkDesign}
                              maxLength={2000}
                              readOnly={readOnlyProductLinks}
                              placeholder="Link design cho sản phẩm này"
                              onChange={(e) => handleChangeProductLink('linkDesign', e.target.value)}
                           />
                        </div>
                     </div>
                  )}

                  {showMyLinkDesign && (
                     <div className="my-link-design">
                        <label>My Link Design</label>
                        {readOnlyProductLinks ? (
                           item?.myLinkDesign ? (
                              isImageUrl(item.myLinkDesign) ? (
                                 <ImagePreview src={item.myLinkDesign} size={64} fit="contain" />
                              ) : (
                                 <a
                                    href={item.myLinkDesign}
                                    target="_blank"
                                    rel="noreferrer"
                                    className="gx-link my-link-design-value"
                                    onClick={(e) => e.stopPropagation()}
                                 >
                                    {item.myLinkDesign}
                                 </a>
                              )
                           ) : (
                              <span className="my-link-design-empty">--</span>
                           )
                        ) : (
                           <Input.TextArea
                              autoSize={{ minRows: 1, maxRows: 3 }}
                              defaultValue={item?.myLinkDesign}
                              maxLength={2000}
                              placeholder="Link design kho cho sản phẩm này"
                              onChange={(e) => handleChangeProductLink('myLinkDesign', e.target.value)}
                           />
                        )}
                     </div>
                  )}
               </div>
            </Card>

            {type === 'edit' ? (
               <div className="trash-wrapper">
                  <Tooltip title="Xoá sản phẩm">
                     <DeleteOutlined style={{ fontSize: 18, color: '#ff4d4f', cursor: 'pointer' }} onClick={onDelete} />
                  </Tooltip>
               </div>
            ) : null}
         </div>
      </CartItemWrapper>
   )
}

export default CardItem
